import { render, staticRenderFns } from "./DeleteParticipant.vue?vue&type=template&id=4c61097c"
import script from "./DeleteParticipant.vue?vue&type=script&lang=js"
export * from "./DeleteParticipant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports